
import { LocationController } from "@/app/ui/controllers/LocationController";
import { Vue, Options, prop } from "vue-class-component";
import MultipleSelectSearchVirtualScroll from "@/app/ui/components/multiple-select-search-virtual-scroll/index.vue";

class Prop {
  form = prop<any>({
    required: true,
    type: Object
  });
  isChangeDistrict = prop<boolean>({
    default: false
  });
}

@Options({
  components: {
    MultipleSelectSearchVirtualScroll
  }
})
export default class SectionAreaDelivery extends Vue.with(Prop) {
  searchValue = "";
  districtMultipleData: any[] = [];
  citiesList: any[] = [];
  loadingGetCityList = false;
  hasMoredata = true;
  currentPage = 1;
  indexActive = 0;

  get isAddButtonDisabled() {
    return this.form.partnerAreaDelivery.some(
      (item: any) => item.cityCode === "" || item.district.length === 0
    );
  }

  districtDisabled(index: number) {
    return this.form.partnerAreaDelivery[index].cityCode === "";
  }

  handleCityChange(index: number) {
    this.form.partnerAreaDelivery[index].district = [];
    this.filterDistrictMultiple(
      "",
      this.form.partnerAreaDelivery[index].cityCode.code
    );
  }

  handleFocus(index: number) {
    this.indexActive = index;
    this.filterDistrictMultiple(
      "",
      this.form.partnerAreaDelivery[index].cityCode.code
    );
  }

  handleFocusChangeCity() {
    this.fetchCityList("");
  }

  addPartnerAreaDelivery() {
    this.form.partnerAreaDelivery.push({
      cityCode: "",
      district: []
    });
  }

  removePartnerAreaDelivery(index: number) {
    this.form.partnerAreaDelivery.splice(index, 1);
  }

  async fetchCityList(search: string) {
    try {
      this.loadingGetCityList = true;
      const res = await LocationController.getDestinationCities({
        search: search,
        status: "",
        page: 1,
        limit: 10
      });
       // Get existing city codes from partnerAreaDelivery
      const existingCityCodes = this.form.partnerAreaDelivery?.map(
        (area: any) => area.cityCode?.code
      ) || [];

      // Filter cities that are not already in partnerAreaDelivery
      this.citiesList = res.data
        .filter((e: any) => !existingCityCodes.includes(e.code))
        .map((e: any) => ({
          ...e,
          name: `${e.code} - ${e.name}`
        }));
      this.loadingGetCityList = false;
    } catch (error) {
      console.log(error);
      this.loadingGetCityList = false;
    }
  }

  filterDistrictMultiple(search: string, cityCode = "") {
    this.searchValue = search;
    this.currentPage = 1;
    try {
      LocationController.getDistrictListByCityCode({
        search: this.searchValue,
        cityCode: cityCode || this.form.partnerAreaDelivery[this.indexActive].cityCode.code,
        page: 1,
        limit: 50
      }).then((res) => {
        this.districtMultipleData = res.map((e) => ({
          name: `${e.name}`,
          code: `${e.code}`
        }));
        this.hasMoredata = true;
        if (res.length > 0) {
          this.currentPage++;
        }
      });
    } catch (error) {
      console.log(error);
    }
  }

  handleLoadMore(index: number) {
    if (!this.hasMoredata) return;
    try {
      LocationController.getDistrictListByCityCode({
        search: this.searchValue,
        cityCode: this.form.partnerAreaDelivery[index].cityCode.code,
        page: this.currentPage,
        limit: 50
      }).then((res) => {
        this.districtMultipleData = [
          ...this.districtMultipleData,
          ...res.map((e) => ({
            name: `${e.name}`,
            code: `${e.code}`
          }))
        ];
        this.hasMoredata = res.length >= 10;
        if (res.length > 0) {
          this.currentPage++;
        }
      });
    } catch (error) {
      console.log(error);
    }
  }
}
